module.exports = __webpack_public_path__ + "static/media/iitmadrasbsc.647524c6.png";